(() => {
  const root = document.querySelector('#tws-front, .tws-site-head');
  if (!root) return;
  const one = selector => root.querySelector(selector);
  const all = selector => [...root.querySelectorAll(selector)];
  const menu = one('#shop-menu');
  const search = one('#q');
  const suggestions = one('#suggest');
  const searchForm = search.form;
  let hoverOpened = false;
  let menuTimer, searchTimer, pendingRequest, photo = 0;

  function closeSearch() {
    clearTimeout(searchTimer);
    pendingRequest?.abort();
    suggestions.hidden = true;
  }

  function showMenu(show) {
    clearTimeout(menuTimer);
    menu.hidden = !show;
    if (!show) hoverOpened = false;
    all('[data-menu]').forEach(button => button.setAttribute('aria-expanded', String(show)));
    if (show) closeSearch();
  }

  function chooseGroup(row) {
    all('[data-group]').forEach(item => {
      const selected = item === row;
      item.classList.toggle('active', selected);
      item.querySelector('button').setAttribute('aria-pressed', String(selected));
      document.getElementById('list-' + item.dataset.group).hidden = !selected;
    });
  }

  function returnToNav() {
    showMenu(false);
    all('[data-menu]').find(button => button.offsetWidth)?.focus();
  }

  for (const row of all('[data-group]')) {
    row.querySelector('button').addEventListener('click', () => chooseGroup(row));
    row.querySelector('button').addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      chooseGroup(row);
      document.getElementById('list-' + row.dataset.group).querySelector('a').focus();
    });
    row.querySelector('a').addEventListener('focus', () => chooseGroup(row));
  }

  const shop = one('.shoplink');
  shop.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && menu.hidden) { showMenu(true); hoverOpened = true; } });
  menu.addEventListener('pointerenter', () => clearTimeout(menuTimer));
  for (const node of [shop, menu]) {
    node.addEventListener('pointerleave', event => {
      if (event.pointerType === 'mouse') menuTimer = setTimeout(() => showMenu(false), 260);
    });
  }
  all('[data-menu]').forEach(button => button.addEventListener('click', () => {
    showMenu(menu.hidden || hoverOpened);
    hoverOpened = false;
  }));
  one('#closemenu').addEventListener('click', returnToNav);
  one('header').addEventListener('focusout', event => {
    if (!one('header').contains(event.relatedTarget)) showMenu(false);
  });

  function configuration() {
    return JSON.parse(one('[data-tws-home-config]').textContent);
  }

  function changePhoto(delta) {
    const slides = configuration().gallery;
    photo = (photo + delta + slides.length) % slides.length;
    const [src, title, alt] = slides[photo];
    one('#herophoto').src = src;
    one('#herophoto').alt = alt;
    one('#figtitle').textContent = title;
  }

  function setService(key) {
    const [src, alt, title, desc, action, href] = configuration().services[key];
    one('#workphoto').src = src;
    one('#workphoto').alt = alt;
    one('#worktitle').textContent = title;
    one('#workdesc').textContent = desc;
    one('#worklink span').textContent = action;
    one('#worklink').href = href;
    all('.tabs button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.service === key)));
    showMenu(false);
  }

  root.addEventListener('click', event => {
    const trigger = event.target.closest('[data-service],#prevpic,#nextpic,.drawerlinks a');
    if (trigger?.dataset.service && one('[data-tws-home-config]')) setService(trigger.dataset.service);
    else if (trigger?.id === 'prevpic') changePhoto(-1);
    else if (trigger?.id === 'nextpic') changePhoto(1);
    else if (trigger) showMenu(false);
  });

  async function findProducts(term) {
    const controller = new AbortController();
    pendingRequest = controller;
    const url = new URL(searchForm.dataset.suggestUrl, location.origin);
    url.search = new URLSearchParams({q:term, section_id:'tws-home-suggest','resources[type]':'product',
      'resources[limit]':'5','resources[options][fields]':'title,product_type,variants.title,variants.sku,vendor'}).toString();
    const resultPage = new URL(searchForm.action);
    resultPage.search = new URLSearchParams({type:'product', q:term}).toString();
    const more = document.createElement('a');
    more.textContent = 'See All Results For “' + term + '” →';
    more.href = resultPage.href;
    try {
      const response = await fetch(url, {signal:controller.signal});
      if (!response.ok) throw Error('Search unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted || search.value.trim() !== term) return;
      suggestions.replaceChildren(...page.querySelectorAll('[data-matches] > a'), more);
    } catch (error) {
      if (controller.signal.aborted) return;
      suggestions.replaceChildren(more);
    }
    if (!controller.signal.aborted && document.activeElement === search) suggestions.hidden = false;
  }

  function queueSearch() {
    closeSearch();
    const term = search.value.trim();
    if (term.length < 2) return;
    showMenu(false);
    searchTimer = setTimeout(() => findProducts(term), 180);
  }
  search.addEventListener('input', queueSearch);
  search.addEventListener('focus', queueSearch);
  search.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown' && !suggestions.hidden) {
      event.preventDefault();
      suggestions.querySelector('a')?.focus();
    }
  });
  one('.searcharea').addEventListener('focusout', event => {
    if (!one('.searcharea').contains(event.relatedTarget)) closeSearch();
  });
  searchForm.addEventListener('submit', closeSearch);
  document.addEventListener('click', event => {
    if (!menu.contains(event.target) && !shop.contains(event.target) && !event.target.closest('[data-menu]')) showMenu(false);
    if (!event.target.closest('.searcharea')) closeSearch();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (!menu.hidden) returnToNav();
    if (!suggestions.hidden) { search.focus(); closeSearch(); }
  });
})();


